// Single source of truth for platform values — the Postgres enum
// (packages/db/src/schema/llm-results.ts), API validation, and dashboard
// pickers all derive from this instead of retyping the list.
export const LLM_PLATFORMS = [
    'chatgpt',
    'claude',
    'gemini',
    'perplexity',
    'groq',
    'google-ai',
    'chatgpt-search',
    'claude-search',
];
// Platforms a tenant can pick to run a live simulation against. Excludes
// 'groq', which createContentLLMClient() uses only as an internal fallback
// for content generation (see apps/api/src/lib/ai/providers.ts) and is
// never offered as a scan platform in the dashboard.
export const SIMULATION_PLATFORMS = [
    'chatgpt',
    'claude',
    'gemini',
    'perplexity',
    'google-ai',
    'chatgpt-search',
    'claude-search',
];
// Per-scan credit cost by platform. Everything defaults to 1 (a plain LLM
// call). 'chatgpt-search' and 'claude-search' call out to OpenAI's/
// Anthropic's real-time web search tools, which carry their own per-search
// fee on top of token costs — genuinely pricier than every other platform,
// which are either plain completions (chatgpt/claude/gemini) or already
// have search priced into their normal per-call cost (perplexity, the
// Gemini-grounded google-ai). Single source of truth for both the API's
// credit debit and the dashboard's cost estimates — see
// apps/api/src/lib/ai/credits.ts and the Simulator/Automation pages.
const DEFAULT_PLATFORM_QUERY_CREDIT_COST = 1;
export const PLATFORM_QUERY_CREDIT_COST = {
    'chatgpt-search': 2,
    'claude-search': 2,
};
export function platformQueryCreditCost(platform) {
    return PLATFORM_QUERY_CREDIT_COST[platform] ?? DEFAULT_PLATFORM_QUERY_CREDIT_COST;
}
export function sumPlatformQueryCredits(platforms) {
    return platforms.reduce((sum, p) => sum + platformQueryCreditCost(p), 0);
}
//# sourceMappingURL=product.js.map